module.exports = __webpack_public_path__ + "img/ww.b1eed089.jpg";